import { useEffect } from "react";

export const useMainContentLogic = () => {
  useEffect(() => {
    const learnMoreLink = document.getElementById("link");

    if (learnMoreLink) {
      learnMoreLink.addEventListener("click", function (event) {
        event.preventDefault();
      });
    }

    return () => {
      if (learnMoreLink) {
        learnMoreLink.removeEventListener("click", function (event) {
          event.preventDefault();
        });
      }
    };
  }, []);

  useEffect(() => {
    const table = document.querySelector("table");

    if (table) {
      const cells = table.querySelectorAll("td");

      cells.forEach(cell => {
        if (cell.textContent.trim() === "true") {
          cell.innerHTML = '<span class="true-value"></span>';
        } else if (cell.textContent.trim() === "false") {
          cell.innerHTML = '<span class="false-value"></span>';
        }
      });
    }
  }, []);
};
